/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_No_FollowInputs */



/**
* | output |
* | --- |
* | "Wundo support off" |
*
* @param {Meetings_Exception_No_FollowInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_no_follow = /** @type {((inputs?: Meetings_Exception_No_FollowInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_No_FollowInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo-ondersteuning uit")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Accompagnement Wundo désactivé")
	return /** @type {LocalizedString} */ ("Wundo support off")
});